module.exports = __webpack_public_path__ + "media/icons/call-bee9f658.svg";